import { axiosInstance } from "../config";

export default {
  state: {
    AllPartnersCRM: [],
  },
  mutations: {
    SetAllPartnersCRM(state, payload) {
      state.AllPartnersCRM = payload;
    },
  },
  actions: {
    async LoadAllAgentsCRM({ commit }) {
      return await axiosInstance
        .get("/agent/property_count")
        .then(function (data) {
          commit("SetAllPartnersCRM", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error.response.data.message,
          };
        });
    },
    async CreateAgent(commit, payload) {
      const formData = new FormData();
      for (const key in payload) {
        if (
          Object.prototype.hasOwnProperty.call(payload, key) &&
          payload[key] !== undefined
        ) {
          formData.append(key, payload[key]);
        }
      }
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/agent", formData, config)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error.response.data.message,
          };
        });
    },
    async SaveAgentPut(commit, payload) {
      const formData = new FormData();
      formData.append("_method", "PUT");
      for (const key in payload.data) {
        if (
          Object.prototype.hasOwnProperty.call(payload.data, key) &&
          payload.data[key] !== undefined
        ) {
          formData.append(key, payload.data[key]);
        }
      }
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/agent/" + payload.ID, formData, config)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error.response.data.message,
          };
        });
    },
    async AgentDeleteById(commit, payload) {
      return await axiosInstance
        .delete("/agent/" + payload)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error.response.data.message,
          };
        });
    },
    async TransferRealEstateAgent(commit, payload) {
      return await axiosInstance
        .get(`/agent/transfer/${payload.from}/${payload.to}`)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error.response.data.message,
          };
        });
    },
  },
  getters: {
    getAllPartnersCRM: (state) => state.AllPartnersCRM,
  },
};
